const _regionNames = new Intl.DisplayNames(['en'], { type: 'region' });

export const isValidCountryCode = (code: string): boolean => {
  // ISO alpha-2 format check
  if (!/^[A-Z]{2}$/.test(code)) {
    return false;
  }

  try {
    const displayName = _regionNames.of(code);
    // Intl.DisplayNames echoes back the input (or returns undefined) for unrecognized codes
    return displayName !== undefined && displayName !== code;
  } catch {
    return false;
  }
};
